import MijnParticipationBox from './mijn-participation-box';
export default MijnParticipationBox;
